import {SurveyDefinitionModel} from "data/models/survey";
import {BrandTraitsTitle} from "components/Survey/survey-sections-rendering-components/BrandTraitsTitles";
import {
  ExamplesOfBrandImages,
  FormattedQuestion
} from "components/Survey/survey-sections-rendering-components/ExamplesOfBrands";

export const VISUAL_RECOMMENDATIONS: SurveyDefinitionModel = {
  id: "visual-recommendations",
  surveyQuestions: [
    {
      id: "visualize-your-brand",
      title: "Visualize your brand.",
      description: "Review the logos below and picture them with your business name." +
          " Select 3-5 logos that have a style that you might like to represent your business.",
      kind: "visual-options-graphic",
      maxScreenWidth: "lg",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {},
    },
    {
      id: "brand-traits",
      title: BrandTraitsTitle,
      description: "These are your primary brand traits based on your responses.",
      kind: "brand-traits",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
      },
    }, {
      id: "examples-of-brands",
      title: "Examples of brands with similar brand traits",
      description: "Look at the choices they’ve made in their design to reflect those traits." +
          " Typography, colors, graphics, and imagery bring to mind certain characteristics." +
          " Their visual styles are clues of what to expect from the product or service that they represent." +
          " While most of these examples are consumer products," +
          " every type of business should develop a brand that expresses their brand traits in a visual way.",
      kind: "paragraphs",
      maxScreenWidth: "md",
      required: false,
      backButtonText: null,
      nextButtonText: null,
      options: {
        textAlignment: "center",
        paragraphs: [
          ExamplesOfBrandImages,
          FormattedQuestion,
        ],
      },
    },
    {
      id: "choose-brand-font",
      title: "Recommended fonts",
      description: null,
      kind: "fonts",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
      },
    },
    {
      id: "choose-brand-color",
      title: "Choose your brand colors.",
      description: null,
      kind: "colors3",
      maxScreenWidth: "lg",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {},
    },
  ],
}
